import { StreamFormat, type Stream } from "../types/model.types";

export const isTextStreamFormat = (format: StreamFormat) => {
  return (
    format === StreamFormat.TEXT ||
    format === StreamFormat.LIVE_TEXT ||
    format === StreamFormat.AUDIO_AND_TEXT ||
    format === StreamFormat.LIVE_AUDIO_AND_TEXT
  );
};

export const isAudioStreamFormat = (format: StreamFormat) => {
  return (
    format === StreamFormat.AUDIO ||
    format === StreamFormat.LIVE_AUDIO ||
    format === StreamFormat.AUDIO_AND_TEXT ||
    format === StreamFormat.LIVE_AUDIO_AND_TEXT
  );
};

export const isLiveFormat = (format: StreamFormat) => {
  return (
    format === StreamFormat.LIVE_TEXT ||
    format === StreamFormat.LIVE_AUDIO ||
    format === StreamFormat.LIVE_AUDIO_AND_TEXT
  );
};

export const isUdpStream = (stream: Stream) => {
  return stream.streamUrl.startsWith("udp://");
};
